import { Loader2, LucideIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button, ButtonProps } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export interface IconActionButtonProps extends Omit<ButtonProps, 'children'> {
  isLoading?: boolean
  isDisabled?: boolean
}

interface Props extends IconActionButtonProps {
  icon: LucideIcon
  tooltip: string
}

export const IconActionButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      icon: Icon,
      tooltip,
      isLoading,
      isDisabled,
      disabled,
      variant,
      size = 'icon',
      'aria-label': ariaLabel,
      ...props
    },
    ref,
  ) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          variant={variant}
          size={size}
          disabled={isDisabled || isLoading || disabled}
          aria-label={ariaLabel ?? tooltip}
          {...props}
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Icon className="h-4 w-4" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  ),
)
IconActionButton.displayName = 'IconActionButton'
